<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { useStoryStore } from "%/dynamic-component-editor/stores/story-store";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "ParentStoryTitle",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.FOLDERS,
    displayName: "Parent Story Title",
    displayIcon: "mdi:folder-account",
    elementGroup: "storyElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [StoryPageElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  data() {
    return {
      parentStory: null,
    };
  },
  computed: {
    isEditable() {
      return false;
    },
    parentFolderId() {
      return Number(this.entity?.myFolder) || 0;
    },
    value() {
      if (this.editMode) {
        return "Parent Story";
      }
      return this.parentStory?.storyTitle || this.parentStory?.title || "";
    },
  },
  watch: {
    parentFolderId: {
      immediate: true,
      handler(folderId) {
        if (this.editMode || !folderId) {
          this.parentStory = null;
          return;
        }
        useStoryStore().getOrFetchStory(folderId).then(story => {
          this.parentStory = story;
        });
      },
    },
  },
};
</script>
